<script setup lang="ts">

import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { faCloudArrowUp } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { convertBytes } from '@shared/lib/convert-bytes'
import { TextQuaternary, TextSecondary } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/icon'

import { fileMaxSize } from '../../config/dropzone'

defineOptions({
  name: 'DropzoneBlock',
})

withDefaults(defineProps<DropzoneBlockProps>(), {
  title: 'drag & drop here',
  acceptedFilesType: 'PDF, DOC, DOCX, JPEG and PNG',
  isOverDropZone: false,
  mode: 'normal',
})

const emit = defineEmits<{
  'click:drop': []
}>()

interface DropzoneBlockProps {
  title?: string
  acceptedFilesType?: string
  isOverDropZone?: boolean
  mode?: InputMode
}

const dropZoneRef = useTemplateRef<HTMLElement>('dropZoneRef')

defineExpose({
  dropZoneRef,
})

</script>

<template>
  <div
    ref="dropZoneRef"
    :class="['drop-block__container', { 'drag-active': isOverDropZone, 'is-error': mode === 'error' }]"
    @click="emit('click:drop')"
  >
    <IconContainer>
      <FontAwesomeIcon :icon="faCloudArrowUp" />
    </IconContainer>
    <TextSecondary>
      <span class="drop-block__upload">Upload a file</span> or {{ title }}
    </TextSecondary>
    <TextQuaternary class="drop-block__detail">
      Accepted files: {{ acceptedFilesType }} up to {{ convertBytes(fileMaxSize) }}
    </TextQuaternary>
  </div>
</template>

<style scoped lang="scss" src="./DropzoneBlock.scss" />
